<template>
    <div v-html="getItemValue"></div>
</template>

<script>
  export default {
    name: 'AddressItemTemplate',

    props: {
      item: {required: true},
      searchText: {required: true}
    },

    computed: {
      getItemValue() {
        return this.item.label;
      }
    }
  }
</script>